<template>
  <div class="page_back_bar bg_white">
    <span class="page_back" @click="pageBack"><i class="fas fa-chevron-left"></i></span>
  </div>

</template>

<script>
export default {
  props: ['backLinkName'],
  methods: {
    pageBack() {
      this.$router.push({ name: this.backLinkName});
    }
  }
}
</script>

<style lang="css" scoped>
.page_back_bar {
  left: 0;
  padding: 0;
  position: fixed;
  padding-left: 10px;
  /* padding-top: 10px; */
  top: 0;
  width: 100%;
}
.page_back {

}
.page_back i {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pageback.vue